import { useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_968_22858)">
        <path
          d="M10.2324 21.2802C15.8383 21.2802 20.3827 16.7357 20.3827 11.1298C20.3827 5.52396 15.8383 0.979492 10.2324 0.979492C4.6265 0.979492 0.0820312 5.52396 0.0820312 11.1298C0.0820312 16.7357 4.6265 21.2802 10.2324 21.2802Z"
          fill="#F0F0F0"
        />
        <path
          d="M2.18219 4.94971C1.38487 5.98706 0.783662 7.1827 0.433594 8.48159H5.71407L2.18219 4.94971Z"
          fill="#0052B4"
        />
        <path
          d="M20.0343 8.48155C19.6842 7.1827 19.083 5.98706 18.2857 4.94971L14.7539 8.48155H20.0343Z"
          fill="#0052B4"
        />
        <path
          d="M0.433594 13.7778C0.783702 15.0767 1.38491 16.2723 2.18219 17.3096L5.71396 13.7778H0.433594Z"
          fill="#0052B4"
        />
        <path
          d="M16.4147 3.07725C15.3773 2.27993 14.1817 1.67872 12.8828 1.32861V6.60906L16.4147 3.07725Z"
          fill="#0052B4"
        />
        <path
          d="M4.05469 19.1807C5.09205 19.978 6.28769 20.5792 7.58654 20.9293V15.6489L4.05469 19.1807Z"
          fill="#0052B4"
        />
        <path
          d="M7.58649 1.32861C6.28765 1.67872 5.09201 2.27993 4.05469 3.07721L7.58649 6.60901V1.32861Z"
          fill="#0052B4"
        />
        <path
          d="M12.8828 20.9293C14.1817 20.5792 15.3773 19.978 16.4146 19.1807L12.8828 15.6489V20.9293Z"
          fill="#0052B4"
        />
        <path
          d="M14.7539 13.7778L18.2857 17.3097C19.083 16.2724 19.6842 15.0767 20.0343 13.7778H14.7539Z"
          fill="#0052B4"
        />
        <path
          d="M20.2968 9.80589H11.5564H11.5564V1.06541C11.123 1.00899 10.6811 0.979492 10.2324 0.979492C9.78358 0.979492 9.34181 1.00899 8.90843 1.06541V9.80581V9.80585H0.167952C0.111531 10.2393 0.0820312 10.6811 0.0820312 11.1298C0.0820312 11.5786 0.111531 12.0204 0.167952 12.4538H8.90835H8.90839V21.1943C9.34181 21.2507 9.78358 21.2802 10.2324 21.2802C10.6811 21.2802 11.123 21.2507 11.5563 21.1943V12.4539V12.4538H20.2968C20.3532 12.0204 20.3827 11.5786 20.3827 11.1298C20.3827 10.6811 20.3532 10.2393 20.2968 9.80589Z"
          fill="#D80027"
        />
        <path
          d="M12.8789 13.7784L17.4083 18.3078C17.6167 18.0996 17.8154 17.8818 18.005 17.6562L14.1272 13.7783H12.8789V13.7784Z"
          fill="#D80027"
        />
        <path
          d="M7.58416 13.7783H7.58408L3.05469 18.3077C3.26293 18.516 3.48065 18.7148 3.70633 18.9044L7.58416 15.0265V13.7783Z"
          fill="#D80027"
        />
        <path
          d="M7.58312 8.4817V8.48162L3.05368 3.95215C2.84536 4.16039 2.64664 4.37811 2.45703 4.60379L6.3349 8.48166H7.58312V8.4817Z"
          fill="#D80027"
        />
        <path
          d="M12.8789 8.48208L17.4084 3.95257C17.2001 3.74425 16.9824 3.54552 16.7567 3.35596L12.8789 7.23383V8.48208V8.48208Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_968_22858">
          <rect
            width="20.3007"
            height="20.3007"
            fill="white"
            transform="translate(0.0820312 0.979492)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgComponent;
